import { CartEntity } from "@features/cart/domain";
import { country } from "@features/country/data";
import { getSizedImage, ImageSize } from "@features/shared/data";
import { CartModel } from "../models";

export function mapCart(cart: CartModel): CartEntity {
  return {
    ...cart,
    products: cart.products.map(product => {
      const colorAttribute = product.attributes.find(
        attr => attr.type === "color",
      );
      const sizeAttribute = product.attributes.find(
        attr => attr.type === "size",
      );

      const selectedPrice = product.appliedDiscount?.applied
        ? product.appliedDiscount.price
        : product.originalPricePerItem;

      const selectedProfit = product.appliedDiscount?.applied
        ? product.appliedDiscount.profit
        : product.originalProfitPerItem;

      return {
        ...product,
        picture: getSizedImage(product.picture, ImageSize.small),
        finalProfitPerItem: product.finalProfitPerItem ?? 0,
        vatPerItem: product.vatPerItem ?? 0,
        finalProfit: Math.max(
          (product.desiredPrice - selectedPrice + selectedProfit) * product.qty,
          0,
        ),
        finalPricePerItem: product.finalPricePerItem ?? 0,
        originalProfitPerItem: product.originalProfitPerItem ?? 0,
        originalPricePerItem: product.originalPricePerItem ?? 0,
        netProfitPerItem: product.netProfitPerItem ?? 0,
        productMaxPrice: product.productMaxPrice ?? 0,
        productId: product.prodId,
        showDiscountedPriceBlock:
          (product.appliedDiscount?.applied ?? false) ||
          (product.qty > 1 &&
            product.originalPricePerItem === product.finalPricePerItem),
        color: colorAttribute?.value,
        size: sizeAttribute?.value,
      };
    }),
    canSubmitOrder:
      cart.products?.every(p => p.isAvailableToSeller && p.validity.isValid) ??
      false,
    shouldShowVAT: (country?.data?.vat ?? 0) > 0,
  };
}
